import { render } from "./TabPane.vue?vue&type=template&id=2ba21eb9"
import script from "./TabPane.vue?vue&type=script&lang=js"
export * from "./TabPane.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__